var _ = require('underscore');

var TorsoView = require('backbone-torso/modules/View');

/**
 * Default view for the tableRow for the brecTable Widget.
 *
 * This view is almost certainly going to be overwritten
 * by your own view because you'll want to have actual
 * logic on here. This serves as a demo for what you'll
 * do to set that view up with a custom template.
 *
 * @class ConciergeTableRowView
 * @constructor
 * @param options {Object}
 *   @param options.context {Object} itemContext passed in from the list view.
 *     @param options.context.tableState {Torso.Cell} the shared state of the widget (filters, search, paging, fetching... etc.).
 *     @param [options.context.template=this.template] {Function} Template to use
 */
module.exports = TorsoView.extend({
  tagName: 'tr',
  className: 'brec-table__tr brec-table__tr--alternative-row',

  /**
   * @method constructor
   * @param options {Object}
   *   @param options.context {Object} itemContext passed in from the list view.
   *     @param options.context.tableState {Torso.Cell} the shared state of the widget (filters, search, paging, fetching... etc.).
   *     @param [options.context.template=this.template] {Function} Template to use
   * @override
   */
  constructor: function(options) {
    var defaultOptions = {
      tableState: null,
      template: this.template
    };
    options = options || {};
    var contextOptions = _.defaults({}, options.context, defaultOptions);
    this.template = contextOptions.template;
    this._tableState = contextOptions.tableState;

    TorsoView.apply(this, arguments);
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = TorsoView.prototype.prepare.apply(this);
    templateContext.tableState = this._tableState.toJSON();
    return templateContext;
  }
});
